module.exports = __webpack_public_path__ + "img/ipadTheme-upgrade.83bf598c.svg";